/*@ngInject*/
const UpdateCollaborationNoteRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.updateCollaborationNote = function (noteId, data) {
        let url = '/rest/Note/' + noteId,
            config = {
                params: data
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('updateCollaborationNoteRepository', UpdateCollaborationNoteRepository);
